import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetLabourUnitQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';

import {WorkshopUnitsDetailForm} from './components/WorkshopUnitsDetailForm';

export function WorkshopUnitsDetail() {
  const {id} = useParams();

  const {
    data: labourUnit,
    isLoading,
    isError,
  } = useGetLabourUnitQuery({labourUnitId: id as string}, {skip: isNilOrEmpty(id)});

  const header: SettingsTemplateHeader = {
    title: isNil(id) ? i18n.t('entity.workshop.actions.newUnit') : (labourUnit?.name ?? ''),
    breadcrumbs: [
      {
        label: i18n.t('entity.workshop.labels.units'),
        href: settingsRoutes.workshopUnits,
      },
    ],
  };

  const titleKey = isNil(id) ? 'entity.workshop.actions.newUnit' : 'entity.workshop.labels.units';

  return (
    <>
      <Helmet title={i18n.t(titleKey)} />
      <SettingsTemplate
        header={header}
        isLoading={isLoading}
        isError={isError}
        data-testid={testIds.settings.workshopUnitDetail('template')}
      >
        <WorkshopUnitsDetailForm
          labourUnit={labourUnit}
          data-testid={testIds.settings.workshopUnitDetail('workshopUnitsDetailForm')}
        />
      </SettingsTemplate>
    </>
  );
}
